function initializeProductCards() {
    const productCards = document.querySelectorAll(".custom-product-card");

    productCards.forEach((card) => {
        card.querySelectorAll(".card-product-opt").forEach((e, i) =>
            e.addEventListener("click", function () {
                this.parentNode.querySelector(".card-product-opt.active").classList.remove("active");
                this.classList.add("active");

                const priceDiv = card.querySelector(".pcard-price");
                let price = "";

                if (i === 0) {
                    price = priceDiv.dataset.fvarprice;
                } else {
                    price = priceDiv.dataset.svarprice;
                }

                priceDiv.textContent = price;
            })
        );
    });

    document.querySelectorAll(".custom-add-to-cart-btn").forEach((item) => {
        item.addEventListener("click", (e) => {
            const svg = item.querySelector("svg");
            svg.classList.remove("hidden");

            let variantValue, sellingPlan;
            const parent = item.parentNode.parentNode.parentNode;
            if (parent.querySelector(".card-product-opt.active")) {
                variantValue = parent.querySelector(".card-product-opt.active").dataset.variantid;
                sellingPlan = parent.querySelector(".card-product-opt.active").parentNode.querySelector(".card-product-spa").dataset.spa;
            } else {
                variantValue = parent.querySelector(".card-product-default-variant").dataset.variantid;
            }

            const variantId = variantValue;
            const object = {
                items: [
                    {
                        id: variantId,
                        selling_plan: sellingPlan,
                        quantity: 1,
                    },
                ],
                sections: ["cart-drawer", "cart-icon-bubble"],
            };

            addItem(object, svg);
        });
    });
}

async function addItem(object, svg) {
    fetch("/cart/add.js", {
        body: JSON.stringify(object),
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
            const cartForm = new DOMParser().parseFromString(json.sections["cart-drawer"], "text/html").getElementById("CartDrawer-Form").innerHTML;

            const interestFreePaymentsStrong = new DOMParser().parseFromString(json.sections["cart-drawer"], "text/html").querySelector(".interest_free_payments_strong").innerHTML;
            const cartBubble = new DOMParser().parseFromString(json.sections["cart-icon-bubble"], "text/html").getElementById("shopify-section-cart-icon-bubble").innerHTML;

            document.querySelector("#CartDrawer-Form").innerHTML = cartForm;
            document.querySelector("#cart-icon-bubble").innerHTML = cartBubble;
            handleShippingProgressbar();
            document.querySelector(".interest_free_payments_strong").innerHTML = interestFreePaymentsStrong;
            svg?.classList.add("hidden");

            if (document.querySelector("cart-drawer").classList.contains("is-empty")) {
                document.querySelector("cart-drawer").classList.remove("is-empty");
                document.querySelector("cart-drawer-items").classList.remove("is-empty");
                document.querySelector("#CartDrawer-Checkout").disabled = false;
            }

            document.querySelector("cart-drawer").open();
            document.querySelector("#CartDrawer-Form").scrollIntoView({ block: "start", behavior: "smooth" });
        });
}

window.addEventListener("DOMContentLoaded", () => initializeProductCards());